// @flow
/* eslint-disable no-restricted-globals,ta-code-conventions/has-matching-storydoc,ta-code-conventions/has-matching-test */
import * as React from 'react';
import * as ReactDOM from 'react-dom';

type Props = {
  [key: string]: any,
  children?: React.Node,
};

/**
 * Renders children in the overlay portal. Note that it renders elements in a <div/>, and props are forwarded into this wrapper
 */
const OverlayPortal = React.forwardRef<Props, _>((props: Props, ref) => {
  if (typeof document === 'undefined' || !document.body) {
    console.error(
      'Attempting to render a portal on server-side! This will cause hydration mismatches.' +
        ' Portals should be rendered in response to an event or client callback',
    );
    return null;
  }
  // In React internals, elements are appended to the Portal container if any of these conditions apply
  // 1. On mount
  // 2. If the element type of the container changes
  // 3. if the physical DOM container backing the element changes
  // To keep the behavior consistent with the virtual DOM portal so only key changes change ordering, elements are rendered in a wrapper div
  return ReactDOM.createPortal(<div {...props} ref={ref} />, document.body);
});

OverlayPortal.displayName = 'OverlayPortal';

export default OverlayPortal;
